//
// Module for edit of benefit formula table
//
rs.module("content/system_/configuration/benefitformulatables/edit",

    [
        "controls/data/grid",
        "controls/components/event-banner"
    ],

    function (gridModule, eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, periodGridLrsApi, periodDetailGridLrsApi, ageMultiplierTableUploadControl, columnIds, ajaxUrls, codeValues) {

            // ensure errors are not cleared on postback,
            // only execute on selection
            var _executePeriodGridSelectionChanged;
            var _executePeriodDetailGridSelectionChanged;

            var tableForm = $.js(jsSelectors.tableForm);
            var tableType = tableForm.js(jsSelectors.tableType);
            var referenceNumber = tableForm.js(jsSelectors.referenceNumber);

            var periodCard = $.js(jsSelectors.periodCard);
            var periodForm = periodCard.js(jsSelectors.periodForm);

            var addPeriodButton = periodCard.js(jsSelectors.addPeriodButton);

            var periodForm = periodCard.js(jsSelectors.periodForm);

            var periodUpdateToken = periodForm.js(jsSelectors.periodUpdateToken);
            var periodKey = periodForm.js(jsSelectors.periodKey);
            var periodReferenceNumber = periodForm.js(jsSelectors.periodReferenceNumber);
            var effectiveDate = periodForm.js(jsSelectors.effectiveDate);
            var terminationDate = periodForm.js(jsSelectors.terminationDate);

            // age based multiplier only
            var fileName = periodForm.js(jsSelectors.fileName, { required: false });

            var cancelPeriodButton = periodForm.js(jsSelectors.cancelPeriodButton);

            var periodDetailCard = $.js(jsSelectors.periodDetailCard);
            var periodDetailCardHeader = periodDetailCard.js(jsSelectors.periodDetailCardHeader);

            var addPeriodDetailButton = periodDetailCard.js(jsSelectors.addPeriodDetailButton);

            var periodDetailForm = periodDetailCard.js(jsSelectors.periodDetailForm);

            var periodDetailUpdateToken = periodDetailForm.js(jsSelectors.periodDetailUpdateToken);
            var periodDetailKey = periodDetailForm.js(jsSelectors.periodDetailKey);
            var periodDetailParentKey = periodDetailForm.js(jsSelectors.periodDetailParentKey);

            // shared
            var age = periodDetailForm.js(jsSelectors.age, { required: false });
            var multiplier = periodDetailForm.js(jsSelectors.multiplier, { required: false });

            // graduated multiplier
            var serviceFrom = periodDetailForm.js(jsSelectors.serviceFrom, { required: false });
            var serviceTo = periodDetailForm.js(jsSelectors.serviceTo, { required: false });

            // graduated reduction factor
            var originalAgeLookupFlag = periodDetailForm.js(jsSelectors.originalAgeLookupFlag, { required: false });
            var originalServiceLookupFlag = periodDetailForm.js(jsSelectors.originalServiceLookupFlag, { required: false });

            var service = periodDetailForm.js(jsSelectors.service, { required: false });
            var factor = periodDetailForm.js(jsSelectors.factor, { required: false });

            // tiered age adjustment
            var overAge = periodDetailForm.js(jsSelectors.overAge, { required: false });
            var underAge = periodDetailForm.js(jsSelectors.underAge, { required: false });

            var savePeriodDetailButton = periodDetailForm.js(jsSelectors.savePeriodDetailButton);
            var cancelPeriodDetailButton = periodDetailForm.js(jsSelectors.cancelPeriodDetailButton);

            // only call select function of periodGridLrsApi not on postback
            periodGridLrsApi.selectionChanged(function (values, rows) {
                if (_executePeriodGridSelectionChanged && values.length > 0) {
                    OnPeriodGridRowSelect(rows[0]);
                }

                _executePeriodGridSelectionChanged = true;
            });

            // only call select function of periodDetailGridLrsApi not on postback
            periodDetailGridLrsApi.selectionChanged(function (values, rows) {
                if (_executePeriodDetailGridSelectionChanged && values.length > 0) {
                    OnPeriodDetailGridRowSelect(rows[0]);
                }

                _executePeriodDetailGridSelectionChanged = true;
            });

            // when add of period is clicked
            // clear errors and grid selection, default values
            // clear and disable Period Detail
            addPeriodButton.click(function () {
                ClearErrorsAndInfoMessagesOfPeriodForm();

                periodGridLrsApi.selectedValues = null;

                ClearOrDefaultFieldsOfPeriodForm();


                setPeriodDetailCardHeader(null, null);

                ClearErrorsAndInfoMessagesOfPeriodDetailForm();

                periodDetailGridLrsApi.clearGridRows();

                ClearOrDefaultFieldsOfPeriodDetailForm();

                togglePeriodDetail(false);
            });

            // when add of period detail is clicked
            // clear errors and grid selection, default values
            addPeriodDetailButton.click(function () {
                ClearErrorsAndInfoMessagesOfPeriodDetailForm();

                periodDetailGridLrsApi.selectedValues = null;

                ClearOrDefaultFieldsOfPeriodDetailForm();
            });

            // reset period grid selection
            cancelPeriodButton.click(function () {
                ResetPeriodGridRowSelection();
            });

            // Either select the first row of the Period Grid or manually clear related fields 
            function ResetPeriodGridRowSelection() {
                if (periodGridLrsApi.agGridApi.getDisplayedRowCount() == 0) {
                    // if no rows exist, call for clearing of errors and defaulting of fields that'd normally be called in select event
                    ClearErrorsAndInfoMessagesOfPeriodForm();
                    ClearOrDefaultFieldsOfPeriodForm();

                } else if (periodGridLrsApi.agGridApi.getSelectedNodes().length && periodGridLrsApi.agGridApi.getSelectedNodes()[0].childIndex == 0) {
                    // if already on first row, selectionChanged won't be fired, so manually call select for row
                    OnPeriodGridRowSelect(periodGridLrsApi.selectedRows[0]);

                } else {
                    periodGridLrsApi.selectFirstRow();
                }
            }

            // reset period detail grid selection
            cancelPeriodDetailButton.click(function () {
                ResetPeriodDetailGridRowSelection();
            });

            // Either select the first row of the Period Detail Grid or manually clear related fields 
            function ResetPeriodDetailGridRowSelection() {
                if (periodDetailGridLrsApi.agGridApi.getDisplayedRowCount() == 0) {
                    // if no rows exist, call for clearing of errors and defaulting of fields that'd normally be called in select event
                    ClearErrorsAndInfoMessagesOfPeriodDetailForm();
                    ClearOrDefaultFieldsOfPeriodDetailForm();

                } else if (periodDetailGridLrsApi.agGridApi.getSelectedNodes().length && periodDetailGridLrsApi.agGridApi.getSelectedNodes()[0].childIndex == 0) {
                    // if already on first row, selectionChanged won't be fired, so manually call select for row
                    OnPeriodDetailGridRowSelect(periodDetailGridLrsApi.selectedRows[0]);

                } else {
                    periodDetailGridLrsApi.selectFirstRow();
                }
            }

            // on selection of a period grid row,
            // clear errors and messages and set fields for new selection,
            // set period detail card
            function OnPeriodGridRowSelect(selectedRow) {
                ClearErrorsAndInfoMessagesOfPeriodForm();

                if (tableType.val() == codeValues.ageBasedMultiplier) {
                    ageMultiplierTableUploadControl.clear();
                }

                $.get(
                    ajaxUrls.getPeriod,
                    { tableType: tableType.val(), periodKey: selectedRow[columnIds.periodKey] },

                    function (data) {
                        periodUpdateToken.val(data.updateToken);
                        periodKey.val(data.periodKey);
                        periodReferenceNumber.val(data.referenceNumber);

                        if (tableType.val() == codeValues.ageBasedMultiplier) {
                            fileName.val(data.importFileName);
                        }

                        var effectiveDateFromResult = data.effectiveDate ? new Date(data.effectiveDate) : null;
                        var terminationDateFromResult = data.terminationDate ? new Date(data.terminationDate) : null;

                        effectiveDate.val(effectiveDateFromResult ? effectiveDateFromResult.toISODateString() : null);
                        terminationDate.val(terminationDateFromResult ? terminationDateFromResult.toISODateString() : null);

                        setPeriodDetailCardHeader(effectiveDateFromResult, terminationDateFromResult);
                    }
                );

                gridModule.update(
                    ajaxUrls.getPeriodDetails,
                    { tableType: tableType.val(), periodKey: selectedRow[columnIds.periodKey] },
                    periodDetailGridLrsApi.agGridApi,
                    function done() {
                        ResetPeriodDetailGridRowSelection();
                    }
                );

                togglePeriodDetail(true);
            }

            // on selection of a period detail grid row,
            // clear errors and messages and set fields for new selection
            function OnPeriodDetailGridRowSelect(selectedRow) {
                ClearErrorsAndInfoMessagesOfPeriodDetailForm();

                $.get(
                    ajaxUrls.getPeriodDetail,
                    { tableType: tableType.val(), periodDetailKey: selectedRow[columnIds.periodDetailKey] },

                    function (data) {
                        periodDetailUpdateToken.val(data.updateToken);

                        if (tableType.val() == codeValues.ageBasedMultiplier) {
                            age.val(data.age);
                            multiplier.val(data.multiplier);
                        } else if (tableType.val() == codeValues.graduatedMultiplier) {
                            serviceTo.val(data.serviceCreditHighLimitAmount);
                            serviceFrom.val(data.serviceCreditLowLimitAmount);
                            multiplier.val(data.primaryMultiplier);
                        } else if (tableType.val() == codeValues.graduatedReductionFactor) {
                            service.val(data.service);
                            factor.val(data.factor);
                            age.val(data.age);
                        } else if (tableType.val() == codeValues.tieredAgeAdjustment) {
                            underAge.val(data.underage);
                            factor.val(data.factor);
                            overAge.val(data.overage);
                        }

                        periodDetailKey.val(data.periodDetailKey);
                        periodDetailParentKey.val(data.periodKey);
                    }
                );
            }

            // clear messages and client validation of period fields
            function ClearErrorsAndInfoMessagesOfPeriodForm() {
                eventBanner.removeAllMessages();

                var inputsToClearErrors =
                    [
                        periodUpdateToken,
                        periodKey,
                        periodReferenceNumber,
                        effectiveDate,
                        terminationDate
                    ];

                if (tableType.val() == codeValues.ageBasedMultiplier) {
                    inputsToClearErrors.push(fileName);
                }

                inputsToClearErrors.forEach((input) => input.clearErrors());
            }

            // clear messages and client validation of detail period fields
            function ClearErrorsAndInfoMessagesOfPeriodDetailForm() {
                eventBanner.removeAllMessages();

                var inputsToClearErrors =
                    [
                        periodDetailUpdateToken,
                        periodDetailKey,
                        periodDetailParentKey
                    ];

                if (tableType.val() == codeValues.ageBasedMultiplier) {
                    inputsToClearErrors.push(
                        age,
                        multiplier
                    );
                } else if (tableType.val() == codeValues.graduatedMultiplier) {
                    inputsToClearErrors.push(
                        serviceFrom,
                        serviceTo,
                        multiplier
                    );
                } else if (tableType.val() == codeValues.graduatedReductionFactor) {
                    inputsToClearErrors.push(
                        age,
                        service,
                        factor
                    );
                } else if (tableType.val() == codeValues.tieredAgeAdjustment) {
                    inputsToClearErrors.push(
                        overAge,
                        underAge,
                        factor
                    );
                }

                inputsToClearErrors.forEach((input) => input.clearErrors());
            }

            // set the period fields for Add
            function ClearOrDefaultFieldsOfPeriodForm() {
                periodKey.val('-1');
                periodReferenceNumber.val(referenceNumber.val());

                var inputsToSetToEmpty =
                    [
                        periodUpdateToken,
                        effectiveDate,
                        terminationDate
                    ];

                if (tableType.val() == codeValues.ageBasedMultiplier) {
                    inputsToSetToEmpty.push(fileName);
                    ageMultiplierTableUploadControl.clear();
                }

                inputsToSetToEmpty.forEach((input) => input.val(''));
            }

            // set the detail period fields for Add
            function ClearOrDefaultFieldsOfPeriodDetailForm() {
                periodDetailKey.val('-1');
                periodDetailParentKey.val(periodKey.val());

                var inputsToSetToEmpty = [periodDetailUpdateToken];

                if (tableType.val() == codeValues.ageBasedMultiplier) {
                    inputsToSetToEmpty.push(
                        age,
                        multiplier
                    );
                } else if (tableType.val() == codeValues.graduatedMultiplier) {
                    inputsToSetToEmpty.push(
                        serviceFrom,
                        serviceTo,
                        multiplier
                    );
                } else if (tableType.val() == codeValues.graduatedReductionFactor) {
                    inputsToSetToEmpty.push(
                        age,
                        service,
                        factor
                    );
                } else if (tableType.val() == codeValues.tieredAgeAdjustment) {
                    inputsToSetToEmpty.push(
                        overAge,
                        underAge,
                        factor
                    );
                }

                inputsToSetToEmpty.forEach((input) => input.val(''));
            }

            // enable/disable the Period Detail card
            function togglePeriodDetail(enable) {

                var controlsToToggle =
                    [
                        addPeriodDetailButton,
                        savePeriodDetailButton,
                        cancelPeriodDetailButton
                    ];

                if (tableType.val() == codeValues.ageBasedMultiplier) {
                    controlsToToggle.push(
                        age,
                        multiplier
                    );
                } else if (tableType.val() == codeValues.graduatedMultiplier) {
                    controlsToToggle.push(
                        serviceFrom,
                        serviceTo,
                        multiplier
                    );
                } else if (tableType.val() == codeValues.graduatedReductionFactor) {
                    controlsToToggle.push(
                        factor
                    );

                    if (enable) {
                        if (originalAgeLookupFlag.val() === 'True') {
                            controlsToToggle.push(
                                age
                            );
                        }

                        if (originalServiceLookupFlag.val() === 'True') {
                            controlsToToggle.push(
                                service
                            );
                        }
                    }
                } else if (tableType.val() == codeValues.tieredAgeAdjustment) {
                    controlsToToggle.push(
                        overAge,
                        underAge,
                        factor
                    );
                }

                controlsToToggle.forEach((control) => control.prop('disabled', !enable));
            }

            // with the given dates, set the appropriate Period Detail header
            function setPeriodDetailCardHeader(effectiveDate, terminationDate) {
                var cardHeader = 'Table Detail';

                if (effectiveDate) {
                    var terminationDateForHeader = 'Present';
                    if (terminationDate) {
                        terminationDateForHeader = terminationDate.toLocaleDateString("en-US");
                    }

                    cardHeader += ` (${effectiveDate.toLocaleDateString("en-US")} - ${terminationDateForHeader})`;
                }

                periodDetailCardHeader.html(cardHeader);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);